import { QueryResult } from '@apollo/client';
import { Money } from '@betterment/core';
import { Separator } from '@betterment/samba-react';

import { BorderedBox } from './BorderedBox';
import { BoxTitle } from './BoxTitle';
import { EstimatedTradeTimingQuery } from './graphql/query.estimatedTradeTiming.generated';
import { ReviewSecurityAmount } from './ReviewSecurityAmount';
import { SaleDetailsRow } from './SaleDetailsRow';
import { TradeTimingRow } from './TradeTimingRow';
import { AmountChoice } from './types';

export type ReviewOrderDetailsProps = {
  assetName: string;
  assetTicker: string;
  pricePerShare: Money;
  tradeTimingResult: Pick<QueryResult<EstimatedTradeTimingQuery>, 'data' | 'error'>;
  willSellAll?: boolean;
} & AmountChoice;

export const ReviewOrderDetails: React.FC<ReviewOrderDetailsProps> = props => {
  const { assetName, assetTicker, pricePerShare, tradeTimingResult, ...amountChoice } = props;
  const security = assetName && assetTicker ? `${assetName} (${assetTicker})` : '—';

  return (
    <BorderedBox css={{ display: 'flex', flexDirection: 'column', gap: 'space.0' }}>
      <BoxTitle>Order details</BoxTitle>
      <Separator />
      <SaleDetailsRow>
        <SaleDetailsRow.Label>Security</SaleDetailsRow.Label>
        <SaleDetailsRow.Value>{security}</SaleDetailsRow.Value>
      </SaleDetailsRow>
      <Separator />
      <SaleDetailsRow>
        <SaleDetailsRow.Label>Amount</SaleDetailsRow.Label>
        <ReviewSecurityAmount pricePerShare={pricePerShare} {...amountChoice} />
      </SaleDetailsRow>
      <Separator />
      <TradeTimingRow tradeTimingResult={tradeTimingResult} />
    </BorderedBox>
  );
};
